import repository from "../Repository";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`adjustment_system_info`, payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.post(`adjustment_operation_log_delete`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
